module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-seasons-pick-4649c400b33b56af04f57677d58b22c0.jpg";